import React from 'react';

import { arrayOf, node, oneOfType, bool } from 'prop-types';
import { useTheme } from '@thd-olt-component-react/theme-provider';
import {
  Typography, Button,
} from '@one-thd/sui-atomic-components';

export const EmptyMessagingPhp = (props) => {

  const { children, error } = props;
  const theme = useTheme(EmptyMessagingPhp, props);
  const { showListIcon } = theme.props;

  const emptyMessageObj = showListIcon
    ? {
      header: 'Plan Out Your Projects',
      firstParagraph: 'Create multiple product lists to help you stay organized and prepare bids',
    }
    : {
      header: 'Great Projects Start With a List',
      firstParagraph: 'Add products to lists to keep organized',
      secondParagraph: 'Save products to purchase later',
      thirdParagraph: 'Reorder frequently purchased products',
    };
  const errorMessageObj = {
    header: 'Have a List?',
    firstParagraph: 'To view your saved lists, sign in to your account.'
  };
  const firstText = showListIcon
    ? <Typography height="normal">{ emptyMessageObj.firstParagraph }</Typography>
    : (
      <li className="sui-font-regular sui-ml-2 sui-text-base sui-leading-normal">
        { emptyMessageObj.firstParagraph }
      </li>
    );

  return (
    <div
      className="sui-paper sui-paper-outlined sui-rounded-base sui-w-full sui-h-full
      sui-p-4 sui-grid sui-gap-10"
      data-component="EmptyMessagingPhp"
    >
      <div>
        <div className="sui-w-full sui-flex sui-justify-between">
          <Typography variant="h3">My Lists</Typography>
          <Button variant="text" href="/list/view/summary">View All</Button>
        </div>
        <div className="sui-mb-3 sui-mt-6">
          <Typography variant="body-base" weight="bold">
            { (!error) ? emptyMessageObj.header : errorMessageObj.header }
          </Typography>
        </div>
        { (error) && (<Typography height="normal">{ errorMessageObj.firstParagraph }</Typography>) }
        { (!error) && firstText }
        { (emptyMessageObj?.secondParagraph && emptyMessageObj?.thirdParagraph && !error) && (
          <>
            <li className="sui-font-regular sui-ml-2 sui-text-base sui-leading-normal">
              { emptyMessageObj.secondParagraph }
            </li>
            <li className="sui-font-regular sui-ml-2 sui-text-base sui-leading-normal">
              { emptyMessageObj.thirdParagraph }
            </li>
          </>
        ) }
      </div>
      <div className="sui-w-full sui-grid sui-items-end">
        { children }
      </div>
    </div>
  );
};

EmptyMessagingPhp.displayName = 'UserListsEmptyMessagingPhp';

EmptyMessagingPhp.propTypes = {
  children: oneOfType([node, arrayOf(node)]),
  error: bool
};

EmptyMessagingPhp.defaultProps = {
  children: null,
  error: false
};

EmptyMessagingPhp.themeProps = {
  showListIcon: bool
};

EmptyMessagingPhp.defaultThemeProps = {
  showListIcon: false
};
